import { legacy } from '@/shared/api/client';
import type { VersoSavePayload } from '../model/back-fields';

/** Persiste os blocos do verso no passbook (PUT /passbook/:id/back-fields). */
export async function updateBackFields(
  idPassbook: string,
  payload: VersoSavePayload,
): Promise<void> {
  await legacy.put<{ ok: boolean }>(`/passbook/${idPassbook}/back-fields`, payload, {
    headers: { 'X-Passbook-Id': idPassbook },
  });
}
